import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import '../../index.scss';
import App from '../../components/app';
import { ScrollContext } from 'react-router-scroll-4';
import { connect } from 'react-redux'
import { clear_auth, init_auth } from "../../reducers/Auth";
import { init_filter, clear_filter } from "../../reducers/Filter"
import { requestAuth, requestData } from "../../helper/request";
import AdminRoute from "../../adminRoute";
import PendingRoute from "../../pendingRoute";
import { ToastContainer } from 'react-toastify';
import "./Toast.css"
// Homepage
import Home from '../../components/home';
import Blog from "../blog";
import BlogDetail from "../blog/detail";
import KebijakanPrivasi from "../kebijakan-privasi";
import Pemantauan from "../pemantauan/pemantauan";
// Components
import Dashboard from '../dashboard';

import Profile from '../../components/settings/profile/index';
import MigrasiData from '../settings/migrasi-data/index';
import SettingMobile from '../../components/settings/mobile';
import SettingNotification from '../../components/settings/notification';
import PresensiMobile from '../../components/settings/presensi';
import UserPerusahaan from '../../components/settings/user/index';
import UserLevelPerusahaan from '../../components/settings/user/level';

import Login from '../../components/auth/login';
import LoginV2 from '../../components/auth/login-v2';
import Register from '../../components/auth/register';
import HapusKaryawan from '../../components/auth/hapus-karyawan';
import VerifyEmailHapusKaryawan from "../auth/verifyEmailHapusKaryawan";
import VerifyEmail from '../../components/auth/verifyEmail';
import ResetPasswordPerusahaan from '../../components/auth/resetPassword';
import LupaPassword from '../../components/auth/lupaPassword';
import LupaPasswordV2 from '../auth/lupa-password-v2';
import AktifasiKaryawan from "../aktifasi-karyawan";
import ResetPassword from "../reset-password";
import ResetPasswordV2 from '../auth/reset-password-v2';
import TagihanRegister from "../tagihan-register";
//Pengajuan
import List_izin from "../pengajuan/izin";
import List_lembur from "../pengajuan/lembur";
import List_kasbon from "../pengajuan/kasbon/kasbon";
import Detail_kasbon from "../pengajuan/kasbon/detail/detail";
import List_klaim_beban from "../pengajuan/klaim-beban/klaim-beban";
import List_revisi_data from "../pengajuan/revisi-data/revisi_data";
import PengajuanInventaris from "../pengajuan/inventaris/list";
//karyawan
import List_karyawan from '../../components/karyawan/list-karyawan';
import Add_karyawan from '../../components/karyawan/add-karyawan';
import Detail from '../karyawan/profil/detail';
import Edit_karyawan from '../../components/karyawan/edit-karyawan';
import List_cuti_karyawan from '../../components/karyawan/laporan-cuti/list-cuti-karyawan';
//jabatan
import List_jabatan_karyawan from '../../components/jabatan-karyawan/list-jabatan-karyawan';
import Edit_jabatan_karyawan from '../../components/jabatan-karyawan/edit-jabatan-karyawan';
//shift
import List_shift from '../../components/shift/list';
import Edit_shift from '../../components/shift/edit';
//jam_kerja
import List_Work_Clock from '../../components/jam_kerja/list';
import Edit_Work_Clock from '../../components/jam_kerja/edit';
//absensi
import List_absensi from "../absensi/list";
import Detail_absensi from "../absensi/detail";
import Add_absensi from "../absensi/add";
import Edit_absensi from "../absensi/edit";

import List_absensi_bulan from "../absensi_bulan/list";

import Langganan from "../tagihan-register/langganan";
import ListPaketLangganan from "../tagihan-register/list_paket";
//payroll
import List_istillah from "../payroll-istillah/list"
import EditIstillah from "../payroll-istillah/edit"

import List_GajiKaryawan from "../payroll/list-gaji-karyawan"
import ListCutiKaryawan from "../payroll/list-cuti-karyawan"
import DetailGajiKaryawan from "../payroll/detail-gaji-karyawan"
import List_payroll from "../payroll/list";
import Detail_payroll from "../payroll/detail"
//pengumuman
import List_pengumuman from '../../components/pengumuman/list';
import Add_pengumuman from "../pengumuman/add";
import Detail_pengumuman from "../pengumuman/detail";
import Edit_pengumuman from "../pengumuman/edit";
//divisi
import List_divisi_karyawan from "../divisi_karyawan/list-divisi-karyawan";
import Edit_divisi_karyawan from "../divisi_karyawan/edit-divisi-karyawan";
//lokasi
import List_lokasi_absen from "../lokasi_absen/list-lokasi-absen";
import Add_lokasi_absensi from "../lokasi_absen/add-lokasi-absen";
import Edit_lokasi_absensi from "../lokasi_absen/edit-lokasi-absen";
//outlet
import List_outlet from "../outlet/list";
import Add_outlet from "../outlet/add";
import Edit_outlet from "../outlet/edit";
//kunjungan
import List_kunjungan from "../kunjungan/list";
import List_tracking from "../kunjungan/list_tracking";
import Detail_tracking from "../kunjungan/detail_tracking";
import Detail_kunjungan from "../kunjungan/detail";
import Laporan_Kunjungan from "../kunjungan/laporan_kunjungan";
//pembayaran_kasbon
import KasbonBayar from "../pembayaran-kasbon/list";
import KasbonBayarDetail from "../pembayaran-kasbon/detail";
import configureStore from '../../config/configureStore';
import PayrollSetting from "../payroll/setting";
// guide
import JamkerjaGuide from '../menu-guide/jam-kerja';
import DivisiGuide from '../menu-guide/divisi';
import LokasiGuide from '../menu-guide/lokasi';
import KaryawanGuide from '../menu-guide/karyawan';
import GuideKaryawanAdd from '../menu-guide/karyawan-add';
import GuideKaryawanEdit from '../menu-guide/karyawan-edit';
import GuideKaryawanDetail from '../menu-guide/detail-karyawan';
import NotificationList from "../notification";
import TaskList from "../task/list";
import FinishedTaskList from "../task/finished";
import SettingsTask from "../task/settings";
// shift jam kerja
import AddAgenda from "../agenda/add"
import ListAgenda, {List_Agenda} from "../agenda/list"
import Edit_Agenda from "../agenda/edit"
//agenda
import ShiftJamKerja from "../shift-jam-kerja/list";
import Page404 from "../404";
//inventaris
import ListInventaris from "../inventaris/list-inventaris";
import Istilah_Inventaris from "../inventaris/inventaris-istilah/list";
import IpWhitelist from "../settings/ip-whitelist/list";

const store = configureStore();

class Main extends Component {
    constructor(props) {
        super(props);

        this.state = {
            active: false,
            data: [],
            user: [],
            all_data: []
        };
    }

    componentDidMount() {
        var Auth = localStorage.getItem('Presensi-Auth')
        var AuthKey = localStorage.getItem('Presensi-Auth-Key')
        var AuthUser = localStorage.getItem('Presensi-Auth-User')
        var all_data = localStorage.getItem('Presensi-Company-Data')

        if (Auth != null && AuthKey != null && AuthUser != null)
            this.props.init_auth(Auth, AuthKey, JSON.parse(AuthUser), JSON.parse(all_data))
        if (all_data != null)
            this.props.init_filter(JSON.parse(all_data))
    }

    request = async (action, data, method) => {
        var AuthKey = await localStorage.getItem('Presensi-Auth-Key')

        await requestAuth('auth', AuthKey)
            .then((response) => {
                if (!response.auth) {
                    this.props.clear_auth()
                    this.props.clear_filter()
                }
            })

        if (action && data) {
            var AuthKey = await localStorage.getItem('Presensi-Auth-Key')

            data = { token: AuthKey, ...data }

            if (this.props.user) {
                this.setState({
                    user: this.props.user.p_user_email
                })
            }

            return requestData(action, data, method)
        }
    }

    render() {
        return (
            <BrowserRouter basename={'/'}>
                <ScrollContext>
                    <Switch>
                        {/* <Route exact path="/"
                            render={(props) => {
                                return <Login
                                    request={(action, data, method = 'GET') => requestData(action, data, method)}
                                    {...props} />
                            }} /> */}
                        <Route exact path="/"
                            render={(props) => {
                                return <LoginV2
                                    request={(action, data, method = 'GET') => requestData(action, data, method)}
                                    {...props} />
                            }} />
                        <Route exact path="/absensi"
                            render={(props) => {
                                return <Home
                                    request={(action, data, method = 'GET') => requestData(action, data, method)}
                                    {...props} />
                            }} />
                        <Route exact path="/blog"
                            render={(props) => {
                                return <Blog
                                    request={(action, data, method = 'GET') => requestData(action, data, method)}
                                    {...props} />
                            }} />
                        <Route exact path="/blog/:alias"
                            render={(props) => {
                                return <BlogDetail
                                    request={(action, data, method = 'GET') => requestData(action, data, method)}
                                    {...props} />
                            }} />
                        <Route exact path="/kebijakan-privasi"
                            render={(props) => {
                                return <KebijakanPrivasi
                                    request={(action, data, method = 'GET') => requestData(action, data, method)}
                                    {...props} />
                            }} />
                        {/* <Route exact path="/login"
                            render={(props) => {
                                return <Login
                                    request={(action, data, method = 'GET') => requestData(action, data, method)}
                                    {...props} />
                            }} /> */}
                        <Route exact path="/login"
                            render={(props) => {
                                return <LoginV2
                                    request={(action, data, method = 'GET') => requestData(action, data, method)}
                                    {...props} />
                            }} />
                        <Route exact path="/register/:alias?"
                            render={(props) => {
                                return <Register
                                    request={(action, data, method = 'GET') => requestData(action, data, method)}
                                    {...props} />
                            }} />
                        <Route exact path="/hapus-karyawan"
                               render={(props) => {
                                   return <HapusKaryawan
                                       request={(action, data, method = 'GET') => requestData(action, data, method)}
                                       {...props} />
                               }} />
                        <Route exact path="/verify-hapus-karyawan"
                               render={(props) => {
                                   return <VerifyEmailHapusKaryawan
                                       request={(action, data, method = 'GET') => requestData(action, data, method)}
                                       {...props} />
                               }} />
                        <Route exact path="/verify"
                            render={(props) => {
                                return <VerifyEmail
                                    request={(action, data, method = 'GET') => requestData(action, data, method)}
                                    {...props} />
                            }} />
                        {/* <Route path="/lupa-password"
                            render={(props) => {
                                return <LupaPassword
                                    request={(action, data, method = 'GET') => requestData(action, data, method)}
                                    {...props} />
                            }} /> */}
                        <Route path="/lupa-password"
                            render={(props) => {
                                return <LupaPasswordV2
                                    request={(action, data, method = 'GET') => requestData(action, data, method)}
                                    {...props} />
                            }} />
                        <Route path="/reset-password-perusahaan"
                            render={(props) => {
                                return <ResetPasswordPerusahaan
                                    request={(action, data, method = 'GET') => requestData(action, data, method)}
                                    {...props} />
                            }} />
                        <Route path="/reset-password"
                            render={(props) => {
                                return <ResetPasswordV2
                                    request={(action, data, method = 'GET') => requestData(action, data, method)}
                                    {...props} />
                            }} />
                        <Route path="/karyawan/aktifasi-akun/:id?"
                            render={(props) => {
                                return <AktifasiKaryawan
                                    request={(action, data, method = 'GET') => requestData(action, data, method)}
                                    {...props} />
                            }} />
                        <Route path="/karyawan/reset-password/:token?"
                            render={(props) => {
                                return <ResetPassword
                                    request={(action, data, method = 'GET') => requestData(action, data, method)}
                                    {...props} />
                            }} />
                        <PendingRoute path="/tagihan"
                            component={TagihanRegister}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/*Dashboard*/}
                        <AdminRoute path="/dashboard"
                            component={Dashboard}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/pemantauan"
                            component={Pemantauan}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/notifikasi"
                            component={NotificationList}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/* Agenda */}
                        <AdminRoute path="/agenda/list-agenda"
                            component={ListAgenda}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/agenda/add"
                                    component={AddAgenda}
                                    request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/agenda/edit/:id"
                                    component={Edit_Agenda}
                                    request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/* Guide */}
                        <AdminRoute
                            path="/guide/jam-kerja"
                            component={JamkerjaGuide}
                            request={(action, data, method = 'GET') => this.request(action, data, method)}
                        />
                        <AdminRoute
                            path="/guide/divisi"
                            component={DivisiGuide}
                            request={(action, data, method = 'GET') => this.request(action, data, method)}
                        />
                        <AdminRoute
                            path="/guide/lokasi"
                            component={LokasiGuide}
                            request={(action, data, method = 'GET') => this.request(action, data, method)}
                        />
                        <AdminRoute
                            path="/guide/karyawan"
                            component={KaryawanGuide}
                            request={(action, data, method = 'GET') => this.request(action, data, method)}
                        />
                        <AdminRoute
                            path="/guide/add-karyawan"
                            component={GuideKaryawanAdd}
                            request={(action, data, method = 'GET') => this.request(action, data, method)}
                        />
                        <AdminRoute
                            path="/guide/edit-karyawan/:id"
                            component={GuideKaryawanEdit}
                            request={(action, data, method = 'GET') => this.request(action, data, method)}
                        />
                        <AdminRoute
                            path="/guide/detail-karyawan/:id"
                            component={GuideKaryawanDetail}
                            request={(action, data, method = 'GET') => this.request(action, data, method)}
                        />

                            {/*Setting*/}
                            <AdminRoute path="/settings/profile"
                                component={Profile}
                                request={(action, data, method = 'GET') => this.request(action, data, method)} />
                            <AdminRoute path="/settings/migrasi-data"
                                        component={MigrasiData}
                                        request={(action, data, method = 'GET') => this.request(action, data, method)} />
                            <AdminRoute path="/settings/mobile"
                                        component={SettingMobile}
                                        request={(action, data, method = 'GET') => this.request(action, data, method)} />
                            <AdminRoute path="/settings/presensi"
                                        component={PresensiMobile}
                                        request={(action, data, method = 'GET') => this.request(action, data, method)} />
                            <AdminRoute path="/settings/user"
                                exact={true}
                                component={UserPerusahaan}
                                request={(action, data, method = 'GET') => this.request(action, data, method)} />
                            <AdminRoute path="/settings/user/level"
                                component={UserLevelPerusahaan}
                                request={(action, data, method = 'GET') => this.request(action, data, method)} />
                            <AdminRoute path="/settings/notification"
                                        component={SettingNotification}
                                        request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/*Pengajuan*/}
                        <AdminRoute path="/pengajuan/izin" component={List_izin}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/pengajuan/lembur" component={List_lembur}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/pengajuan/kasbon" component={List_kasbon}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/pengajuan/kasbon-detail/:id" component={Detail_kasbon}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/pengajuan/klaim-beban" component={List_klaim_beban}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/pengajuan/revisi" component={List_revisi_data}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/pengajuan/inventaris" component={PengajuanInventaris}
                                    request={(action, data, method = 'GET') => this.request(action, data, method)} />


                        {/*Karyawan*/}
                        <AdminRoute path="/karyawan/list-karyawan/:page" component={List_karyawan}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/karyawan/tambah-karyawan" component={Add_karyawan}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/karyawan/profil/detail/:karyawan_slug" component={Detail}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/karyawan/edit-karyawan/:karyawan_slug/:page" component={Edit_karyawan}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/laporan-cuti/:page" component={List_cuti_karyawan}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/*Jabatan Karyawan*/}
                        <AdminRoute path="/karyawan/jabatan-karyawan" component={List_jabatan_karyawan}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/karyawan/edit-jabatan-karyawan/:id" component={Edit_jabatan_karyawan}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/*Daftar Gaji*/}
                        <AdminRoute path="/daftar-gaji-karyawan" component={List_GajiKaryawan}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/pengaturan/cuti" component={ListCutiKaryawan}
                                    request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/detail-gaji-karyawan/:id" component={DetailGajiKaryawan}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/daftar-gaji/list" component={List_payroll}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/daftar-gaji/detail/:id" component={Detail_payroll}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/payroll/setting" component={PayrollSetting}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/*Pembayaran Kasbon*/}
                        <AdminRoute path="/pembayaran-kasbon/list" component={KasbonBayar}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/pembayaran-kasbon/detail/:id" component={KasbonBayarDetail}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/*Karyawan Shift*/}
                        <AdminRoute path="/karyawan/shift" component={List_shift}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/karyawan/edit-shift-karyawan/:id" component={Edit_shift}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/* Shift Jam Kerja */}
                        <AdminRoute path="/karyawan/shift-jam-kerja" component={ShiftJamKerja}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/*payroll istilah*/}
                        <AdminRoute path="/daftar-gaji-istillah" component={List_istillah}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/daftar-gaji-istillah/:id" component={EditIstillah}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/*Karyawan Jam Kerja*/}
                        <AdminRoute path="/karyawan/jam-kerja" component={List_Work_Clock}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/karyawan/edit-jamKerja-karyawan/:id" component={Edit_Work_Clock}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/*Tugas*/}
                        <AdminRoute path="/tugas" component={TaskList}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/tugas-selesai" component={FinishedTaskList}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/tugas-pengaturan" component={SettingsTask}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/*Kunjungan*/}
                        <AdminRoute path="/kunjungan/daftar-kunjungan" component={List_kunjungan}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/kunjungan/laporan-kunjungan" component={Laporan_Kunjungan}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/kunjungan/daftar-tracking" component={List_tracking}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/kunjungan/detail-tracking/:id" component={Detail_tracking}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/detail-kunjungan/:id" component={Detail_kunjungan}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/*Pengumuman*/}
                        <AdminRoute path="/pengumuman" component={List_pengumuman}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/tambah-pengumuman" component={Add_pengumuman}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/detail-pengumuman/:id" component={Detail_pengumuman}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/edit-pengumuman/:id" component={Edit_pengumuman}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/*Absensi*/}
                        <AdminRoute path="/presensi" component={List_absensi}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/tambah-presensi" component={Add_absensi}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/detail-presensi/:id" component={Detail_absensi}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/edit-presensi/:id" component={Edit_absensi}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/presensi-bulan" component={List_absensi_bulan}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/*Karyawan Divisi*/}
                        <AdminRoute path="/karyawan/divisi-karyawan" component={List_divisi_karyawan}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/karyawan/edit-divisi-karyawan/:id" component={Edit_divisi_karyawan}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/*Langganan*/}
                        <PendingRoute exact path="/langganan" component={Langganan}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <PendingRoute exact path="/langganan/paket" component={ListPaketLangganan}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/*Lokasi Absensi*/}
                        <AdminRoute path="/lokasi-presensi" component={List_lokasi_absen}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/tambah-lokasi-presensi" component={Add_lokasi_absensi}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/edit-lokasi-presensi/:id" component={Edit_lokasi_absensi}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/*Outlet*/}
                        <AdminRoute path="/lokasi-kunjungan" component={List_outlet}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/tambah-lokasi-kunjungan" component={Add_outlet}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/lokasi-kunjungan/detail/:id" component={Detail_absensi}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute path="/edit-lokasi-kunjungan/:id" component={Edit_outlet}
                            request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        {/*Inventaris*/}
                        <AdminRoute exact path="/inventaris" component={ListInventaris}
                                    request={(action, data, method = 'GET') => this.request(action, data, method)} />
                        <AdminRoute exact path="/inventaris/istilah" component={Istilah_Inventaris}
                                    request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        <AdminRoute path="*" component={Page404} request={(action, data, method = 'GET') => this.request(action, data, method)} />

                        <ToastContainer
                            autoClose={2000}
                            position="top-right"
                            className="toast-container"
                            toastClassName="dark-toast"
                        />
                    </Switch>
                </ScrollContext>
            </BrowserRouter>
        )
    }
}

const mapStateToProps = state => ({
    api_token: state.Auth.api_token,
    user: state.Auth.user,
    data: state.Auth.data,
    all_data: state.Filter.all_data
})

const mapDispatchToProps = dispatch => ({
    init_auth: (api_token, auth_key, data) => dispatch(init_auth(api_token, auth_key, data)),
    clear_auth: () => dispatch(clear_auth()),
    init_filter: (all_data) => dispatch(init_filter(all_data)),
    clear_filter: () => dispatch(clear_filter()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Main)
